import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { deleteReel } from "../../../../api/api";
import { ReelWithCategory } from "../../../../interfaces/tell_me_watch/reel.types";
import { getDataSetToRedux } from "../../../../utility/getAffirmationAndCategory";

interface Props {
    open: boolean,
    reel: ReelWithCategory,
    handleClose: VoidFunction,
}
const ReelsDeleteDialog = (props: Props) => {
    const dispatch = useDispatch();
    const [idText, setIdText] = useState("");

    useEffect(() => {
        setIdText(props.reel.id);
    }, [props.reel])

    const handleSubmit = async () => {
        const response = await deleteReel(props.reel.id);
        await getDataSetToRedux(dispatch);
        
        props.handleClose();
        if (response.success) {
            alert("SUCCESS")
        } else {
            alert("Error");
            console.log(response.message);
        }

    }

    const handleClose = () => {
        setIdText("");
        props.handleClose();
    }

    return (
        <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle style={{ width: 400 }} id="form-dialog-title">Delete a Reel</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    This action will delete the reel from all categories contains it.
                </DialogContentText>

                <Box height={15} />
                <Typography variant="h6">
                    {props.reel.id}
                </Typography>
                <Box height={15} />
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>

                    <Button onClick={handleSubmit} color="primary">
                        Delete
                    </Button>
                </DialogActions>

            </DialogContent>
        </Dialog>
    );
}

export default ReelsDeleteDialog;